import React from 'react';
import { Flex } from '@atlaskit/primitives';
import type { IntlShape } from '@atlassian/jira-intl';
import { messages } from './messages';

export const generateTableHeader = ({ formatMessage }: IntlShape) => ({
	cells: [
		{
			key: 'priorities-table-header-column-1-order',
			content: formatMessage(messages.rowOrderHeader),
			width: 8,
		},
		{
			key: 'priorities-table-header-column-2-icon-and-name',
			content: formatMessage(messages.iconAndNameHeader),
		},
		{
			key: 'priorities-table-header-column-3-description',
			content: formatMessage(messages.descriptionHeader),
		},
		{
			key: 'priorities-table-header-column-4-color',
			content: formatMessage(messages.colorHeader),
			width: 8,
		},
		{
			key: 'priorities-table-header-column-5-schemes',
			content: formatMessage(messages.schemesHeader),
		},
		{
			key: 'priorities-table-header-column-6-actions',
			content: <Flex justifyContent="end">{formatMessage(messages.actionsHeader)}</Flex>,
			width: 16,
		},
	],
});

/**
 * The DynamicTable component handles pagination for us, but does not support async loading of items.
 * In order to show render the correct number of pages, we need to generate dummy rows to pad out the list of rows
 * that we pass into the component.
 */
export const generateFillerRows = (length: number) => {
	if (length <= 0) {
		return [];
	}
	const dummyRows = new Array(length).fill({});
	return dummyRows.map((_, index) => ({
		key: `priorities-table-dummy-row-${index}`,
		cells: [],
	}));
};
